const API_URL = '/waste-company-worker'

export const state = () => ({
  waste_company_workers: [],
  waste_collection_routes: {},
  waste_collections: {},
})

export const getters = {
  get: state => waste_company_worker_id => {
    return state.waste_company_workers.find(
      waste_company_worker => waste_company_worker.id === parseInt(waste_company_worker_id)
    )
  },
}

export const mutations = {
  PUSH_OR_REPLACE_WASTE_COMPANY_WORKER(state, new_waste_company_worker) {
    let waste_company_worker_index = state.waste_company_workers.findIndex(
      waste_company_worker => waste_company_worker.id === parseInt(new_waste_company_worker.id)
    )

    if (waste_company_worker_index >= 0) {
      state.waste_company_workers.splice(waste_company_worker_index, 1, new_waste_company_worker)
    } else {
      state.waste_company_workers.push(new_waste_company_worker)
    }
  },
  REMOVE_WASTE_COMPANY_WORKER(state, waste_company_worker_id) {
    let waste_company_worker_index = state.waste_company_workers.findIndex(
      waste_company_worker => waste_company_worker.id === parseInt(waste_company_worker_id)
    )

    state.waste_company_workers.splice(waste_company_worker_index, 1)
  },
  SET_WASTE_COLLECTION_ROUTES(state, routes) {
    state.waste_collection_routes = routes
  },
  SET_WASTE_COLLECTIONS(state, collections) {
    state.waste_collections = collections
  },
}

export const actions = {
  async fetch({ commit }, waste_company_worker_id) {
    let { data: waste_company_worker } = await useApi(`${API_URL}/${waste_company_worker_id}`)

    commit('PUSH_OR_REPLACE_WASTE_COMPANY_WORKER', waste_company_worker.value)

    return waste_company_worker.value
  },
  async update({ commit }, waste_company_worker) {
    try {
      let { data } = await useApi(`${API_URL}/${waste_company_worker.id}`, {
        method: 'put',
        body: waste_company_worker,
      }) // no data is returned on update

      const updated_waste_company_worker = waste_company_worker
      commit('PUSH_OR_REPLACE_WASTE_COMPANY_WORKER', updated_waste_company_worker)

      return updated_waste_company_worker
    } catch (error) {
      console.error('Error updating worker', error)
      throw error
    }
  },
  async delete({ commit }, waste_company_worker_id) {
    await useApi(`${API_URL}/${waste_company_worker_id}`, { method: 'delete' })

    commit('REMOVE_WASTE_COMPANY_WORKER', waste_company_worker_id)
  },
  async fetchWasteCollectionRoutes({ commit }, { waste_company_worker_id, params }) {
    let { data: routes } = await useApi(`${API_URL}/${waste_company_worker_id}/waste-collection-route`, {
      query: params,
    })

    commit('SET_WASTE_COLLECTION_ROUTES', routes.value?.data)

    return routes.value?.data
  },
  async fetchWasteCollections({ commit }, { waste_company_worker_id, params }) {
    let { data: collections } = await useApi(`${API_URL}/${waste_company_worker_id}/waste-collection`, {
      query: params,
    })

    commit('SET_WASTE_COLLECTIONS', collections.value?.data)

    return collections.value?.data
  },
}
